function SectionTitle({ title }: { title: string }) {
    return <h1 className="text-4xl my-4 font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-blue-400 inline-block">{title}</h1>
}

export default SectionTitle;